<template>
<div>
  
    <div class="bg-white">
      <div class="container">
        <div class="row" style="padding:25px;">
          <h2 class="text-center" style="padding:25px;font-weight:bold;">
          សូមស្វាគមន៍
          </h2>
          <!--  eslint-disable no-use-before-define  -->
          <p class="pf text-center">
            ការចូលប្រព័ន្ធរបស់លោកអ្នកបានជោគជ័យសូមរងចាំ.....
          </p>
          <!--  eslint-enable no-use-before-define  -->
        </div>
      </div>
    </div>
</div>

</template>

<script>
import axios from "@/axios";
export default {
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async handleload() {
      let loader = this.showLoader();
      try {
          let response = await axios.post("login-camdigikey",{
            authToken: this.$route.query.authToken
          });
          if (response.data.status) {
            loader.hide();
            if(response.data.data.need_comfirm){
                this.$store.commit('changeUserCamDigit',response.data.data);
                ///go to confirmation page
                this.$router.push({ name: "competedConfirmation"});
            }else{
              this.$store.commit('changeAuthCode',response.data.data);
              this.$router.push({ name: "Home" });
            }
            // window.location.href = response.data.response.loginUrl;
          } else {
            loader.hide();
            this.$toast.open({
              message: "Login fail " + response.message,
              type: "error",
              duration: 5000,
              dismissible: true,
              position: "top-right"
            });
            this.$router.push({ name: "errorlogin" });
          }
        //console.log("it is respone:", response);
      } catch (error) {
        loader.hide();
        this.$router.push({ name: "errorlogin" });
        //console.log("it is error:", error);
      }
    }
  },
  mounted() {
    this.handleload();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* navbar-transparent */
.bcover{
  display: block;
  position: absolute;
  background: #333;
  height: 110vh;
  border: 1px;
  width: 100%;
  opacity: 0.7;
  z-index: 1;
}
.top {
  color: #fff;
  /* width: 70%; */
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1000;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 70px;
}

.block{
  color: #fff;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bgcover {
  background: url("~@/assets/images/bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  top: 0;
  left: 0;
}

.pf {
  font-size: 18px;
  text-align: justify;
  letter-spacing: -1px;
}

.bg-gray{
  background-color: #f1f1f1;
}

.bg-gray .container{
  background-color: #f1f1f1;
}

@media (max-width: 613px) {
  h3,
  h4,
  button {
    font-size: 14px;
  }
  .top {
    width: 100%;
    padding: 40px;
  }
}
</style>
